import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Snippet, SnippetType } from '@distribute/shared/types';
import { snippetsModel } from '../../../features/snippets';

import { navigate } from '../../../processes/navigation';
import { generatePath } from 'react-router-dom';

import { SNIPPET_EDITOR_ROUTE } from '../../../entities/history';

export const useSnippetCommonActions = () => {
  const dispatch = useDispatch();

  const handleEditSnippet = useCallback(
    (snippet: Snippet) => {
      if (snippet.type === SnippetType.TEXT) {
        dispatch(snippetsModel.actions.setModal(null));
        dispatch(snippetsModel.actions.setCurrentSnippet(snippet));
        dispatch(
          navigate({
            to: generatePath(SNIPPET_EDITOR_ROUTE, {
              sequenceNumber: snippet.sequenceNumber,
            }),
          })
        );
      } else {
        dispatch(
          snippetsModel.actions.setModal({
            type: 'replaceSnippet',
            snippet,
          })
        );
      }
    },
    [dispatch]
  );

  const handlePreviewSnippet = useCallback(
    (snippet: Snippet) => {
      dispatch(
        snippetsModel.actions.setModal({
          type: 'snippetPreview',
          snippet,
        })
      );
    },
    [dispatch]
  );

  return {
    handleEditSnippet,
    handlePreviewSnippet,
  };
};
